// Pure password validation for the set-password page.
//
// FE-side check is deliberately lightweight: it catches the obvious
// bad cases (too short, mismatch) so the user gets an instant signal,
// and defers everything else (email-localpart inclusion, full-name
// match) to the BE. The server still runs `assertPasswordMeetsPolicy`
// and is the source of truth — duplicating that logic on the client
// would diverge over time.

export const MIN_PASSWORD_LENGTH = 12;

/**
 * Returns null when the pair is acceptable, an Italian error string
 * when not. Single function so the page can render exactly one error
 * line under the form, with priority "too short" → "mismatch".
 */
export function validatePasswordPair(
  password: string,
  confirmPassword: string,
): string | null {
  if (typeof password !== 'string' || password.length < MIN_PASSWORD_LENGTH) {
    return `La password deve contenere almeno ${MIN_PASSWORD_LENGTH} caratteri.`;
  }
  if (password !== confirmPassword) {
    return 'Le due password non coincidono.';
  }
  return null;
}
